import { Button } from '@cian/ui-kit/button';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';

export const CalltrackingWarning: React.FC<{ onClick(): void }> = ({ onClick }) => {
  return (
    <div className={styles['container']}>
      <p className={styles['title']}>Вы будете звонить по защищённому номеру</p>

      <p className={styles['description']}>Разговоры записываются: так мы быстрее вычисляем и блокируем мошенников</p>
      <Button
        fullWidth
        beforeIcon={<IconCommunicationPhone16 color="icon-inverted-default" />}
        size="M"
        onClick={onClick}
      >
        Позвонить
      </Button>
    </div>
  );
};
